import { render, staticRenderFns } from "./ManageChannels.vue?vue&type=template&id=34192763&"
import script from "./ManageChannels.vue?vue&type=script&lang=js&"
export * from "./ManageChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports